import type { Image } from '@scripts/frontend/libs/types/media'

export enum OrderStatusEnum {
  CANCELLED = 'cancelled',
  COMPLETED = 'completed',
  CONFIRMS_PAYMENT = 'checking_payment',
  DRAFT = 'draft',
  FAILED = 'failed',
  ON_HOLD = 'on-hold',
  PACKING = 'packing',
  PENDING = 'pending',
  PENDING_PAYMENT = 'pending_payment',
  PROCESSING = 'processing',
  REFUNDED = 'refunded',
}

export type Order = {
  billing: Address
  cartHash: string
  cartTax: number
  createdDate: Date
  createdVia: string
  currency: string
  customerId: number
  customerIpAddress: string
  customerNote: string
  customerUserAgent: string
  dateCompleted: Date | null
  datePaid: Date | null
  discountTax: number
  discountTotal: number
  downloadPermissionsGranted: boolean
  invoicePermalink?: string
  metadata: Metadata
  modifiedDate: Date
  newOrderEmailSent: boolean
  orderId: number
  orderItems: OrderItem[]
  orderKey: string
  orderStockReduced: boolean
  paymentMethod: string
  paymentMethodTitle: string
  paymentPermalink?: string
  permalink: string
  recordedCouponUsageCounts: boolean
  recordedSales: boolean
  shipping: Address
  shippingTax: number
  shippingTotal: number
  status: OrderStatusEnum
  subTotal: number
  total: number
  totalTax: number
  transactionId: string
}

export type OrderItem = {
  image: Image
  isOnSale: boolean
  name: string
  permalink: string
  price: number
  productId: number
  productType: 'variation' | string
  quantity: number
  regularPrice: number
  salePrice: number
  sku: string
  subtotal: number
  subtotalTax: number
  total: number
  totalTax: number
  variationAttributes?: {
    name: string
    value: string
  }[]
}

export type Address = {
  address1: string
  address2: string
  city: string
  company: string
  country: string
  email: string
  firstName: string
  lastName: string
  phone: string
  postcode: string
  state: string
}

export type Metadata = {
  _order_number: string
  _pip_invoice_number: string
  _shipping_email: string
  _wc_order_attribution_referrer: string
  _wc_order_attribution_session_count: string
  _wc_order_attribution_session_entry: string
  _wc_order_attribution_session_pages: string
  _wc_order_attribution_session_start_time: Date
  _wc_order_attribution_source_type: string
  _wc_order_attribution_user_agent: string
  _wc_order_attribution_utm_campaign: string
  _wc_order_attribution_utm_content: string
  _wc_order_attribution_utm_id: string
  _wc_order_attribution_utm_medium: string
  _wc_order_attribution_utm_source: string
  _wc_order_attribution_utm_term: string
  _wc_pip_invoice_email_count: string
  _wc_points_earned: string
  _wc_points_logged_redemption: PointsLoggedRedemption
  is_omise_payment_resolved: string
  is_request_tax_invoice: string
  is_vat_exempt: string
  omise_token: string
  tax_invoice_data: TaxInvoiceData
  token: string
  wc_checkout_address: string
  wc_checkout_billing_address: string
}

export type PointsLoggedRedemption = {
  amount: number
  discount_code: null
  points: number
}

export type TaxInvoiceData = {
  address: string
  company_name: string
  entity_type: string
  name: string
  phone_number: string
  postcode: string
  tax_id: string
}
